import { ComponentHeader, StyledCreate } from "@components";
import { GenerateCdicCouponForm } from "@modules";
import { useTranslation } from "react-i18next";

export const PageGenerateCdicCoupon = () => {
  const { t } = useTranslation();

  return (
    <>
      <ComponentHeader title={t("page.generate_cdic_coupon")} />
      <StyledCreate>
        <GenerateCdicCouponForm />
      </StyledCreate>
    </>
  );
};
